import React, { useState, useEffect, useCallback, FunctionComponent, CSSProperties } from 'react';
import { useDevice } from '../../../hooks/device';
import {
  getFavoriteRecruitment,
  createBookmarkForFavoriteRecruitment,
  deleteBookmarkForFavoriteRecruitment,
} from '../../../services/favoriteRecruitments';
import type { ComponentProps as Props } from './types';
import { Presentation } from './presentation';
import { getCsrfToken } from '../../../libs/csrfToken';

export const Component: FunctionComponent<Props> = (props) => {
  const { isPc } = useDevice();

  const [isPush, setIsPush] = useState(false);
  const [btnStyle, setBtnStyle] = useState<CSSProperties>({});

  const createStyle: CSSProperties = { background: '#808080', color: '#19190F' };
  const deleteStyle: CSSProperties = { background: '#1B1464', color: '#FFFFFF' };

  const handleFetchFavorites = useCallback(async () => {
    try {
      const data = await getFavoriteRecruitment(props.recruitmentId);
      setIsPush(data.isPush);
      setBtnStyle(data.isPush ? createStyle : deleteStyle);
    } catch (error) {
      console.error('Error fetching favorites:', error);
    }
  }, [props.recruitmentId]);

  useEffect(() => {
    handleFetchFavorites();
  }, [handleFetchFavorites]);

  const handleClickCreateBookmark = useCallback(
    async (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      if (props.isPreview) {
        alert('プレビューのため実行できません');
        return;
      }
      try {
        await createBookmarkForFavoriteRecruitment(props.recruitmentId);
        setIsPush(true);
        setBtnStyle(createStyle);
      } catch (error) {
        console.error('Error creating bookmark:', error);
      }
    },
    [props.recruitmentId]
  );

  const handleClickDeleteBookmark = useCallback(
    async (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      try {
        await deleteBookmarkForFavoriteRecruitment({
          recruitmentId: props.recruitmentId,
          csrfToken: getCsrfToken(),
        });
        setIsPush(false);
        setBtnStyle(deleteStyle);
      } catch (error) {
        console.error('Error deleting bookmark:', error);
      }
    },
    [props.recruitmentId]
  );

  const bookmarkOnRecruitmentPanelCategory = useCallback(() => {
    const url = window.location.href;
    if (url.includes('/recruitment_browsing_histories')) {
      return 'browsinghistorycontent';
    } else if (url.includes('/favorite_recruitments')) {
      return 'favoriterecruitmentcontent';
    } else if (url.includes('/companies') && url.includes('/recruitments')) {
      return 'companyrecruitmentlist';
    } else if (url.includes('/recruitments')) {
      return 'recruitmentcontent';
    } else if (url.includes('/brands')) {
      return 'brandcontent';
    }
    return 'recruitmentlist';
  }, []);

  const presentationProps = {
    ...props,
    isPc,
    isPush,
    btnStyle,
    handleClickCreateBookmark,
    handleClickDeleteBookmark,
    bookmarkOnRecruitmentPanelCategory,
  };

  return <Presentation {...presentationProps} />;
};
